<template lang="pug">
main
  NavBar
  ModalKilometros(
    v-show="modalStatus",
    :config="configModal",
    @modalEvent="updateKilometro"
  )
  Loader(v-show="isLoading")
  LoaderInfo(
    v-show="isLoadingInfo",
    :actual="itemsGuardados",
    :total="totalInfo"
  )
  section.section(v-show="verContenido")
    .container
      .columns
        .column.is-half.is-offset-one-quarter.has-text-centered
          h1.title Importar Movimientos de Tarjetas&nbsp
            a.button.is-black.is-rounded(@click="backToPage")
              i.fas.fa-times 
      .columns
        .column.is-12
          input.excel-upload-input(
            ref="excel-upload-input",
            type="file",
            accept=".xlsx, .xls",
            @change="handleClick",
            v-show="verDrop"
          )
          .drop(
            @drop="handleDrop",
            @dragover="handleDragover",
            @dragenter="handleDragover",
            v-show="verDrop"
          )
            | Arrastra un archivo de excel ...
      .columns
        .column.is-12.has-text-centered
          a.button.is-dark(@click="handleUpload", v-show="verDrop")
            | Subir Excel &nbsp
            i.fas.fa-upload
          a.button(@click="handleCancel", v-show="!verDrop")
            | Limpiar&nbsp
            span.icon
              i.fas.fa-trash
      .columns
        .column.is-12(v-show="verTablaMovimientos")
          TbTarjetasMovimientos(
            :movs="movimientosError",
            @seleccionarItem="selectMovimiento"
          )
        .column.is-12(v-show="verTablaAsignaciones")
          span Ver Tabla Asignaciones
      .columns
        .column.is-12
          a.button(@click="handleCancel", v-show="!verDrop")
            | Limpiar&nbsp
            span.icon
              i.fas.fa-trash
      .columns.column-blanco
</template>

<script>
import NavBar from "./layout/NavBarTransportes.vue";
import Loader from "@/components/shared/Loader.vue";
import LoaderInfo from "@/components/shared/LoaderInfo.vue";
import TbTarjetasMovimientos from "./componentes/TbTarjetasMovimientos.vue";
import * as XLSX from "xlsx";;
import InventarioServices from "@/services/inventario/inventario";
import ModalKilometros from "./componentes/ModalKilometros.vue";
import moment from "moment";

export default {
  name: "ImportatTarjetas",
  components: {
    NavBar,
    Loader,
    TbTarjetasMovimientos,
    LoaderInfo,
    ModalKilometros,
  },
  data() {
    return {
      isLoading: false,
      isLoadingInfo: false,
      excelData: {
        header: null,
        results: null,
      },
      filas: null,
      tableData: [],
      verDrop: true,
      verTablaAsignaciones: false,
      verTablaMovimientos: false,
      movimientosError: [],
      movimientos: [],
      asignaciones: [],
      isDisabled: true,
      itemsGuardados: 0,
      tarjetas: [],
      afiliados: [],
      itemsNoGuardados: [],
      totalInfo: 0,
      verContenido: true,
      modalStatus: false,
      configModal: {},
    };
  },
  watch: {
    "excelData.header"() {
      if (this.excelData.header) {
        this.verTablaMovimientos = true;
        this.verTablaAsignaciones = false;
        const movs = this.excelData.results.map(this.convertirMovimientos);
        this.movimientos = movs.filter((m) => m.recorrido >= 0);
        this.subirData();
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },

    isLoading() {
      if (this.isLoading || this.isLoadingInfo) {
        this.verContenido = false;
      } else {
        this.verContenido = true;
      }
    },

    isLoadingInfo() {
      if (this.isLoading || this.isLoadingInfo) {
        this.verContenido = false;
      } else {
        this.verContenido = true;
      }
    },
  },
  methods: {
    iniciarComponente() {
      this.obtenerTarjetas();
    },

    obtenerTarjetas() {
      InventarioServices.getTarjetas_All()
        .then((data) => {
          this.tarjetas = data.map(this.convertirTarjetas);
          this.obtenerAfiliados();
        })
        .catch((e) => {
          this.isLoading = false;
          this.displayToast("bubble", `Error: ${e.message}`, "ban", "OK");
        });
    },
    convertirTarjetas(t) {
      return {
        ...t,
        id: parseInt(t.id),
      };
    },

    obtenerAfiliados() {
      InventarioServices.getTarjetas_Afiliados()
        .then((data) => {
          this.afiliados = data.map(this.convertirAfiliados);
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.displayToast("bubble", `Error: ${e.message}`, "ban", "OK");
        });
    },

    convertirAfiliados(c) {
      return {
        ...c,
        id: parseInt(c.id),
      };
    },

    generateData({ header, results }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.filas = results;
      this.onSuccess && this.onSuccess(this.excelData);
    },

    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.isLoading) return;
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error("Only support uploading one file!");
        return;
      }
      const rawFile = files[0];
      if (!this.isExcel(rawFile)) {
        this.$message.error(
          "Only supports upload .xlsx, .xls, .csv suffix files"
        );
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    handleUpload() {
      this.$refs["excel-upload-input"].click();
    },

    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      this.upload(rawFile);
    },

    handleCancel() {
      this.excelData.header = null;
      this.excelData.results = null;
      this.movimientos = [];
      this.asignaciones = [];
      this.verDrop = true;
      this.verTablaAsignaciones = false;
      this.verTablaMovimientos = false;
    },

    upload(rawFile) {
      this.verDrop = false;
      this.$refs["excel-upload-input"].value = null; // fix can't select the same excel
      if (!this.beforeUpload) {
        this.readerData(rawFile);
        return;
      }
      const before = this.beforeUpload(rawFile);
      if (before) {
        this.readerData(rawFile);
      }
    },

    readerData(rawFile) {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header = this.getHeaderRow(worksheet);
          const movs = XLSX.utils.sheet_to_json(worksheet);
          const results2 = movs.filter(
            (m) => m["__EMPTY"] && m["__EMPTY"].includes("DTE")
          );
          const result3 = results2.filter(
            (m) => m["__EMPTY_12"] && m["__EMPTY_12"] === "TRANSACCIÓN"
          );
          const result4 = result3.map(this.convertirMovimientos);
          const placas = this.getPlacasUnicas(result4);
          const results = this.ordenarPlacas(placas, result4);
          this.generateData({ header, results });
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },

    getPlacasUnicas(movs) {
      const placasTodas = [];
      movs.forEach((mov) => {
        placasTodas.push(mov["placa"]);
      });
      const placas = Array.from(new Set(placasTodas));
      return placas;
    },

    ordenarPlacas(placas, movs) {
      const placasSorted = [];
      placas.forEach((placa) => {
        const placasFiltradas = movs.filter((m) => m["placa"] === placa);
        const placasOrdenadas = placasFiltradas.sort(
          (a, b) =>
            moment(b.fechaTransaccion).format("YYYYMMDD") -
            moment(a.fechaTransaccion).format("YYYYMMDD")
        );
        placasOrdenadas.map((p) => {
          placasSorted.push(p);
        });
      });
      return placasSorted;
    },

    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      range.s.r = 7;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        let hdr = "UNKNOWN " + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },

    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },

    backToPage() {
      this.$router.back();
    },

    convertirMovimientos(mov) {
      const horaString = moment(mov["__EMPTY_5"]).format("HH:mm:ss");
      const _fechaYear =
        mov["__EMPTY_4"] === ""
          ? ""
          : mov["__EMPTY_4"].substring(6, mov["__EMPTY_4"].length);
      const _fechaMonth =
        mov["__EMPTY_4"] === "" ? "" : mov["__EMPTY_4"].substring(3, 5);
      const _fechaDay =
        mov["__EMPTY_4"] === "" ? "" : mov["__EMPTY_4"].substring(0, 2);
      const fechaStr = `${_fechaYear}-${_fechaMonth}-${_fechaDay}`;

      return {
        ...mov,
        identificador: mov["__EMPTY"],
        placa: mov["Detalle de Movimientos por Tarjeta"],
        vehículo: mov["__EMPTY_1"],
        idCC: mov["__EMPTY_2"],
        centroCostos: mov["__EMPTY_3"],
        fechaTransaccion: fechaStr,
        horaTransaccion: horaString,
        noTrx: mov["__EMPTY_6"] ? mov["__EMPTY_6"] : "",
        comprobante: mov["__EMPTY_7"],
        mercancia: mov["__EMPTY_8"],
        kilometrajeAnt: mov["__EMPTY_9"],
        kilometrajeActual: mov["__EMPTY_10"],
        recorrido: mov["__EMPTY_11"],
        tMovimiento: mov["__EMPTY_12"],
        tTarjeta: mov["__EMPTY_13"],
        consumo: mov["__EMPTY_14"],
        capacidad: mov["__EMPTY_15"],
        cantidadMercancia: mov["__EMPTY_16"],
        precioUnitario: mov["__EMPTY_17"],
        saldoAntesTransaccion: mov["__EMPTY_18"],
        importeTransaccion: mov["__EMPTY_19"],
        saldoActual: mov["__EMPTY_20"],
        afiliado: mov["__EMPTY_21"] ? mov["__EMPTY_21"] : "",
        observaciones: mov["__EMPTY_22"] ? mov["__EMPTY_22"] : "",
      };
    },

    subirData() {
      if (this.verTablaMovimientos) {
        this.totalInfo = this.movimientos.length;
        const periodo = moment(this.movimientos[0].fechaTransaccion).format(
          "YYYYMM"
        );
        InventarioServices.borrarImportacionTarjetas(periodo)
          .then((dataDel) => {
            if (dataDel.success) {
              this.isLoading = false;
              this.isLoadingInfo = true;

              this.movimientos.map((mov) => {
                const tarjeta = this.tarjetas.find(
                  (t) => t.identificador === mov.identificador
                );
                const afiliado = this.afiliados.find(
                  (c) => c.nombre === mov.afiliado
                );
                if (mov.recorrido < 0) {
                  const myObjError = {
                    ...mov,
                    index: this.id,
                  };
                  this.movimientosError.push(myObjError);
                }
                if (tarjeta) {
                  if (afiliado) {
                    const id_tarjeta = tarjeta.id;
                    const id_afiliado = afiliado.id;
                    const periodo = `${moment(mov.fechaTransaccion).format(
                      "YYYYMM"
                    )}`;
                    const fechaCompleta = `${mov.fechaTransaccion} ${mov.horaTransaccion}`;
                    InventarioServices.addTarjeta_Movimiento(
                      id_tarjeta,
                      mov.placa,
                      fechaCompleta,
                      periodo,
                      "1",
                      "0.0",
                      mov.importeTransaccion,
                      id_afiliado,
                      mov.kilometrajeAnt,
                      mov.kilometrajeActual,
                      mov.recorrido,
                      mov.comprobante,
                      mov.mercancia,
                      mov.cantidadMercancia,
                      mov.precioUnitario,
                      mov.saldoAntesTransaccion,
                      mov.saldoActual
                    )
                      .then((resp) => {
                        if (resp.success) {
                          this.itemsGuardados = this.itemsGuardados + 1;
                        } else {
                          const obj = {
                            ...mov,
                            index: this.id,
                          };
                          this.itemsNoGuardados.push(obj);
                        }
                        const totalItems =
                          this.itemsGuardados + this.itemsNoGuardados.length;
                        if (totalItems == this.movimientos.length) {
                          this.isLoadingInfo = false;
                          if (
                            this.movimientosError.length > 0 ||
                            this.itemsNoGuardados.length > 0
                          ) {
                            this.itemsNoGuardados.map((i) =>
                              this.movimientosError.push(i)
                            );
                            console.log(this.movimientosError);
                            return;
                          } else {
                            this.backToPage();
                          }
                        }
                        setTimeout(() => {}, 30);
                      })
                      .catch((e) => {
                        this.displayToast(
                          "bubble",
                          `Error: ${e.message}`,
                          "ban",
                          "OK"
                        );
                        const myObjError = {
                          ...mov,
                          index: this.id,
                        };
                        this.movimientosError.push(myObjError);
                      });
                  } else {
                    console.log("No se encontro el afiliado:");
                    // Hay que agregar el afiliado, retornar el id y guardar el item
                    InventarioServices.guardarAfiliado(mov.afiliado)
                      .then((dataAddAfiliado) => {
                        if (dataAddAfiliado.success) {
                          const id_tarjeta = tarjeta.id;
                          const id_afiliado = dataAddAfiliado.id;
                          console.log(id_afiliado);
                          const periodo = `${moment(
                            mov.fechaTransaccion
                          ).format("YYYYMM")}`;
                          const fechaCompleta = `${mov.fechaTransaccion} ${mov.horaTransaccion}`;
                          InventarioServices.addTarjeta_Movimiento(
                            id_tarjeta,
                            mov.placa,
                            fechaCompleta,
                            periodo,
                            "1",
                            "0.0",
                            mov.importeTransaccion,
                            id_afiliado,
                            mov.kilometrajeAnt,
                            mov.kilometrajeActual,
                            mov.recorrido,
                            mov.comprobante,
                            mov.mercancia,
                            mov.cantidadMercancia,
                            mov.precioUnitario,
                            mov.saldoAntesTransaccion,
                            mov.saldoActual
                          )
                            .then((resp) => {
                              if (resp.success) {
                                this.itemsGuardados = this.itemsGuardados + 1;
                              } else {
                                const obj = {
                                  ...mov,
                                  index: this.id,
                                };
                                this.itemsNoGuardados.push(obj);
                                console.log("No guardado" + resp.respuesta);
                              }
                              const totalItems =
                                this.itemsGuardados +
                                this.itemsNoGuardados.length;
                              if (totalItems == this.movimientos.length) {
                                this.isLoadingInfo = false;
                                if (
                                  this.movimientosError.length > 0 ||
                                  this.itemsNoGuardados.length > 0
                                ) {
                                  this.itemsNoGuardados.map((i) =>
                                    this.movimientosError.push(i)
                                  );
                                  console.log(this.movimientosError);
                                  return;
                                } else {
                                  this.backToPage();
                                }
                              }
                              setTimeout(() => {}, 30);
                            })
                            .catch((e) => {
                              this.displayToast(
                                "bubble",
                                `Error: ${e.message}`,
                                "ban",
                                "OK"
                              );
                              const myObjError = {
                                ...mov,
                                index: this.id,
                              };
                              this.movimientosError.push(myObjError);
                            });
                        } else {
                          this.displayToast(
                            "bubble",
                            `Error: ${dataAddAfiliado.message}`,
                            "ban",
                            "OK"
                          );
                        }
                      })
                      .catch((e) => {
                        console.log(e.message);
                      });
                    this.itemsGuardados = this.itemsGuardados + 1;
                    const myObjError = {
                      ...mov,
                      index: this.id,
                    };
                    this.movimientosError.push(myObjError);
                    console.log(mov);
                  }
                } else {
                  console.log("No se encontro el tarjeta");
                  this.itemsGuardados = this.itemsGuardados + 1;
                  console.log(mov);
                }
              });
            } else {
              this.displayToast(
                "bubble",
                `Error: ${dataDel.message}`,
                "ban",
                "OK"
              );
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.displayToast("bubble", `Error: ${e.message}`, "ban", "OK");
          });
        return;
      } else {
        this.totalInfo = this.asignaciones.length;
      }
    },

    guardarPendientes(mov) {
      this.isLoading = false;
      this.isLoadingInfo = true;
      console.log(mov);
      // Correr bucle para guardar los pendientes
      const tarjeta = this.tarjetas.find(
        (t) => t.identificador === mov.identificador
      );
      const afiliado = this.afiliados.find((c) => c.nombre === mov.afiliado);
      if (tarjeta) {
        if (afiliado) {
          const id_tarjeta = tarjeta.id;
          const id_afiliado = afiliado.id;
          const periodo = `${moment(mov.fechaTransaccion).format("YYYYMM")}`;
          const fechaCompleta = `${mov.fechaTransaccion} ${mov.horaTransaccion}`;
          InventarioServices.addTarjeta_Movimiento(
            mov.id,
            id_tarjeta,
            mov.placa,
            fechaCompleta,
            periodo,
            "1",
            "0.0",
            mov.importeTransaccion,
            id_afiliado,
            mov.kilometrajeAnt,
            mov.kilometrajeActual,
            mov.recorrido,
            mov.comprobante,
            mov.mercancia,
            mov.cantidadMercancia,
            mov.precioUnitario,
            mov.saldoAntesTransaccion,
            mov.saldoActual
          )
            .then((resp) => {
              if (resp.success) {
                this.displayToast(
                  "toasted-primary",
                  resp.message,
                  "done",
                  "OK"
                );
                this.isLoading = false;
              } else {
                this.displayToast("bubble", resp.message, "ban", "OK");
              }
              if (this.itemsGuardados == this.movimientos.length) {
                this.isLoadingInfo = false;
                this.backToPage();
              }
            })
            .catch((e) => {
              this.displayToast("bubble", `Error: ${e.message}`, "ban", "OK");
            });
        } else {
          this.displayToast(
            "bubble",
            "No se encontro el afiliado",
            "ban",
            "OK"
          );
        }
      } else {
        this.displayToast("bubble", "No se encontro la tarjeta", "ban", "OK");
      }
    },

    displayToast(tema, text, icon, actionText) {
      let toast = this.$toasted.show(text, {
        theme: tema,
        position: "bottom-right",
        duration: 3000,
        iconPack: "fontawesome",
        icon: icon,
        action: {
          text: actionText,
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      });
    },

    selectMovimiento(mov) {
      const myObj = {
        title: `Actualizar Kilometrajes`,
        content: `¿Desea actualizar los kilometrajes?`,
        textCancel: `Cancelar`,
        textOk: `Actualizar`,
        question1: "Kilómetro Ant.",
        question2: "Kilómetro Actual.",
        question3: "Kilómetros Recorridos.",
        data: mov,
      };
      this.configModal = myObj;
      this.modalStatus = true;
    },

    updateKilometro(data) {
      if (!data.save) {
        this.modalStatus = false;
        return;
      }
      // Guardar en Base de Datos
      // Retirar de la
      this.movimientosError.splice(data.index, 1);
      const mov = data.data.data;
      console.log(mov);
      const obj = {
        ...mov,
        kilometrajeAnt: data.newValues.kmAnterior,
        kilometrajeActual: data.newValues.kmActual,
        recorrido: data.newValues.kmRecorridos,
      };
      this.guardarPendientes(obj);
      this.modalStatus = false;
    },
  },

  created() {
    this.iniciarComponente();
  },
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}
.drop {
  border: 2px dashed #54545c;
  width: 100%;
  height: 260px;
  line-height: 260px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #54545c;
  position: flex;
  justify-content: center;
  align-items: center;
}
.drop:hover {
  border: 2px dashed #d3142c;
  color: #d3142c;
}
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/ImportarTarjetas.vue